import type { ChatFolderPlanError } from "@/lib/chat/chat-folder-plan";
import { orgCopy } from "@/lib/ui/org";

export const chatFolderCopy = {
  create: "Создать папку",
  rename: "Переименовать",
  renameTitle: "Переименовать папку",
  remove: "Удалить папку",
  deleteTitle: "Удалить папку?",
  deleteConfirm: "Удалить",
  deleteHelp: "Чаты останутся в списке без папки.",
  deleteCancel: "Отмена",
  pending: "Сохраняем…",
  nameLabel: "Название папки",
  nameTaken: orgCopy.nameTaken,
  emptyName: orgCopy.invalidName,
  nameTooLong: "Название слишком длинное",
  missing: "Папка не найдена",
  unknown: "Выберите папку из списка",
  errorTitle: "Папка чатов",
  none: "Без папки",
  move: "В папку",
  moveEmpty: "Сначала создайте папку — иконка рядом с «Чаты».",
  moveCreate: "Новая папка…",
  createAndMove: "Создать",
  actions: "Действия с папкой",
  expand: "Развернуть папку",
  collapse: "Свернуть папку",
  empty: "Пусто",
} as const;

export function chatFolderErrorMessage(
  code: ChatFolderPlanError | string,
): string {
  switch (code) {
    case "empty-name":
      return chatFolderCopy.emptyName;
    case "name-too-long":
      return chatFolderCopy.nameTooLong;
    case "name-taken":
      return chatFolderCopy.nameTaken;
    case "missing":
      return chatFolderCopy.missing;
    case "unknown-folder":
      return chatFolderCopy.unknown;
    default:
      return code === "create-failed" || code === "rename-failed"
        ? "Не удалось сохранить папку"
        : code;
  }
}

export type ChatFolderNavItem = {
  id: string;
  name: string;
};

export type ChatNavChatItem = {
  id: string;
  title: string;
  when: string;
  folderId: string | null;
};

export type ChatNavFolderGroup = {
  folder: ChatFolderNavItem;
  chats: ChatNavChatItem[];
};

/** Folders keep sort order; empty folders stay visible; unknown folderId → unfiled. */
export function groupChatNav(params: {
  folders: readonly ChatFolderNavItem[];
  chats: readonly ChatNavChatItem[];
}): { folders: ChatNavFolderGroup[]; unfiled: ChatNavChatItem[] } {
  const byId = new Map<string, ChatNavChatItem[]>(
    params.folders.map((folder) => [folder.id, []]),
  );
  const unfiled: ChatNavChatItem[] = [];
  for (const chat of params.chats) {
    if (chat.folderId && byId.has(chat.folderId)) {
      byId.get(chat.folderId)!.push(chat);
    } else {
      unfiled.push(chat);
    }
  }
  return {
    folders: params.folders.map((folder) => ({
      folder,
      chats: byId.get(folder.id) ?? [],
    })),
    unfiled,
  };
}
